const api = '/cms-service/api/external';

export const templatesContext = {
  templates: `${api}/templates`,
  templateById: `${api}/templates/{id}`,
  createVariable: `${api}/templateVariables`,
  variableById: `${api}/templateVariables/{id}`,
};
